module.exports = __webpack_public_path__ + "img/back centered zipper length.e284d3b8.png";